import { AfterViewInit, Component, Input, OnInit, forwardRef, inject, model, signal, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import {AsyncPipe} from '@angular/common';
import { DateRange } from '@angular/material/datepicker';
import { MatDialog } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { KeycloakService } from 'keycloak-angular';
import { map, Observable, startWith } from 'rxjs';
import { KeycloakAuthService } from 'src/app/auth/keycloak-auth.service';
import { CommonActions } from 'src/app/common/store/actions/common.actions';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';
import { SearchActions } from 'src/app/common/store/actions/search.actions';
import { selectCurrentCar, selectCurrentCarImagesDatas, 
  selectSearchCriteria, selectLoggedInUserDataId, selectDealerData, 
  selectJobTemplates,
  selectProviderCarsByBusinessLine} from 'src/app/common/store/state/app.state';

import { selectMakes, selectModels, selectVersions } from 'src/app/common/store/state/app.state';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { DealerBasicData, DealerType } from 'src/app/public/account/constants/dealer-basic-data';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { CarJobTemplate } from 'src/app/public/car/models/car-job-template.model';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { CarVersion } from 'src/app/public/car/models/car-version.model';
import { Car } from 'src/app/public/car/models/car.model';
import { AppConstants } from 'src/app/public/common/constants/app-constants';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarBasicData, CarBusinessLine } from 'src/app/public/car/constants/car-basic-data';
import { CommonBasicData, ServiceType } from 'src/app/public/common/constants/common-basic-data';
import { GeneralBasicData, ObjectSource } from 'src/app/public/common/constants/general-basic-data';
import { Appointment } from 'src/app/public/common/models/appointment.model';
import { FileData } from 'src/app/public/common/models/file-data.model';
import { CarJobCategory, KeepBasicData } from '../../constants/keep-basic-data';

export interface JobTemplatesGroup {
  category: CarJobCategory;
  templates: CarJobTemplate[];
}

export const _filterByValue = (opt: CarJobTemplate[], value: string): CarJobTemplate[] => {
  const filterValue = value.toLowerCase();

  return opt.filter(item => item.code.toLowerCase().includes(filterValue)  || item.title.toLowerCase().includes(filterValue) );
};

export const _filterByCategoryAndValue = (opt: CarJobTemplate[], category: CarJobCategory, value: string): CarJobTemplate[] => {
  const filterValue = value.toLowerCase();

  return opt.filter(item => ( category == item.category && (item.code.toLowerCase().includes(filterValue)  || item.title.toLowerCase().includes(filterValue) )));
};

@Component({
    selector: 'app-keep-appointment',
    templateUrl: './keep-appointment.component.html',
    styleUrl: './keep-appointment.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class KeepAppointmentComponent implements OnInit {

  currentUserId$: Observable<string>;
  currentUserId: string = '';

  currentCar$: Observable<Car>;
  currentCar: Car = new Car()

  myKeepCars$: Observable<Car[]>;
  myKeepCars: Car[] = [];

  myDealerData$: Observable<Dealer>;
  myKeepProviders: Dealer[] = [];

  carImagesFolder$: Observable<FileData[] | undefined > ;
  carImage: Blob = new Blob();

  @Input() carId: string = '';
  @Input() currentAppointment: Appointment = new Appointment();

  //carMakes: string[] = []; 
  
  makes$: Observable<CarMake[]>;
  models$: Observable<CarModel[]>;
  versions$: Observable<CarVersion[]>;

  makes: CarMake[] = [];
  models: CarModel[] = [];
  versions: CarVersion[] = [];

  selectedMake: CarMake = new CarMake('', '', 0);
  selectedModel: CarModel = new CarModel('', '');
  selectedVersion: CarVersion = new CarVersion('', '');

  carGearBoxes = CarBasicData.gearboxes;
  carFuelTypes = CarBasicData.fuelTypes;

  countryCodeOptions: string[] = AppConstants.COUNTRY_CODE_OPTIONS;
  carYearsBD: number[] = AppFunctions.getCarYearsBD();
    
  serviceTypesBD = CommonBasicData.serviceTypes;
  jobCategoriesBD = KeepBasicData.carJobCategories;
  locationModesBD = CommonBasicData.locationModes;
  
  civilities = DealerBasicData.civilities;
  dealerTypes = DealerBasicData.dealerTypes;

  ServiceType = ServiceType;
  DealerType = DealerType;

  todayDate: Date;
  tomorrowDate: Date;
  yesterdayDate: Date;
  
  isEditable = true;

  driverDayRate = 10000;
  insuranceDayRate = 5000;

  paymentTermOptions = DealerBasicData.paymentTermOptions;
  currentPaymentTermOptionIndex = 1;

  countries = GeneralBasicData.getAllCountries();
  mobileMoneyOperators = DealerBasicData.mobileMoneyOperators;

  emailRegex = AppConstants.EMAIL_REGEX;
  phoneNumberRegex = AppConstants.PHONE_NUMBER_REGEX;

  isNewCar: boolean = false;

  jobTemplates$: Observable<CarJobTemplate[]>;
  jobTemplates: CarJobTemplate[] = [];

  objectSource: ObjectSource = ObjectSource.KEEP


  private _formBuilder = inject(FormBuilder);

  jobTemplatesForm = this._formBuilder.group({
    jobTemplatesGroup: '',
  });

  jobTemplatesGroups: JobTemplatesGroup[] = [
    {
      category: CarJobCategory.BODY,
      templates: [ new CarJobTemplate("ac1", "at1"), new CarJobTemplate("ac2", "at2") ]
    },
    {
      category: CarJobCategory.BRAKES,
      templates: [ new CarJobTemplate("bc1", "bt1"), new CarJobTemplate("bc2", "bt2") ]
    }
  ]

  jobTemplatesGroupOptions: Observable<JobTemplatesGroup[]>;

  jobTemplatesMapOptions: Observable<Map<CarJobCategory, CarJobTemplate[]>>;

  indices: Set<number> = new Set<number>();

  constructor(
    private router: Router,
    public route: ActivatedRoute,
    private store: Store, 
    public kcService: KeycloakAuthService, 
    private readonly sanitizer: DomSanitizer,
    public dialog: MatDialog,
    //private _formBuilder: FormBuilder
    ) {

        //this.carDocumentsFolder$ = store.select(selectDocumentsFolderByCarId("0"));
        //this.currentFileData$ = store.select(selectCurrentFileData);
      this.makes$ = this.store.select(selectMakes);
      this.models$ = this.store.select(selectModels);
      this.versions$ = this.store.select(selectVersions);

      this.jobTemplates$ = this.store.select(selectJobTemplates);

      this.todayDate = new Date();
      this.tomorrowDate = new Date(this.todayDate);
      this.yesterdayDate = new Date(this.todayDate);

      this.tomorrowDate.setDate(this.todayDate.getDate()+1);
      this.yesterdayDate.setDate(this.todayDate.getDate()-1);

      this.currentUserId$ = store.select(selectLoggedInUserDataId);
      this.currentCar$ = store.select(selectCurrentCar);
      this.carImagesFolder$ = store.select(selectCurrentCarImagesDatas);
      
      this.myKeepCars$ = store.select(selectProviderCarsByBusinessLine(CarBusinessLine.KEEP));
      this.myDealerData$ = store.select(selectDealerData);

      if(this.kcService.isLoggedIn()){
        this.isNewCar = false;
        this.store.dispatch(DealerActions.fetchProviderCarsSubmit({businessLine: CarBusinessLine.KEEP}));
        this.store.dispatch(DealerActions.fetchMyProvidersSubmit());
      }

      this.jobTemplatesGroupOptions = this.jobTemplatesForm.get('jobTemplatesGroup')!.valueChanges.pipe(
        startWith(''),
        map(value => this._filterJobTemplates(value || '')),
      );

      this.jobTemplatesMapOptions = this.jobTemplatesForm.get('jobTemplatesGroup')!.valueChanges.pipe(
        startWith(''),
        map(value => this._filterJobTemplatesMap(value || '')),
      );
    }

  ngOnInit(): void {

    //this.carMakes = CarBasicData.getMakesBD();
    this.store.dispatch(CarRefActions.makesFetchSubmit( {}));
    this.store.dispatch(CarRefActions.jobTemplatesFetchSubmit( {}));

    console.log(this.kcService.isLoggedIn());

    this.route.queryParams.subscribe(params => {
      this.carId = params['id'];
    
      if(params['id'] == undefined){
        this.carId = '';
        console.log(params);
        this.isNewCar = true;
        this.selectedMake.name = params["make"];
        this.selectedModel.name = params["model"];

        this.currentAppointment.carMake = params["make"];
        this.currentAppointment.carModel = params["model"];
        this.currentAppointment.customerCity = params["city"];
        this.currentAppointment.customerCountry = params["country"];
        this.currentAppointment.services = params["services"];
        this.currentAppointment.jobCategories = params["categories"];

        console.log(this.selectedMake);
      }
      else{

        this.store.dispatch(SearchActions.fetchCarDetailsSubmit({offerId: '', carId: this.carId, businessLine: CarBusinessLine.KEEP }));
        //this.store.dispatch(SearchActions.fetchSimilarCarBriefsSubmit({carId: this.carId})); 
      }        
    });
    
    //this.store.dispatch(DealerActions.fetchMyCarBasketSubmit({businessLine: CarBusinessLine.KEEP}));
    this.currentUserId$.subscribe(
      (id: string) => {
        this.currentUserId = id;
        
      });

    this.myKeepCars$.subscribe(
      (cars: Car[]) => {
        if(cars !== undefined){
          this.myKeepCars = Object.assign([], cars);
        }
      });

    this.myDealerData$.subscribe(
      (dldt: Dealer) => {
        this.myKeepProviders = dldt.myProviders;
      });

    this.currentCar$.subscribe(
      (c: Car) => {
        //this.currentImageIndex = 0;
        this.currentCar = Object.assign(new Car(), c);
        this.carId = c.carId;

        //this.store.dispatch(SearchActions.fetchSameSellerCarBriefsSubmit({sellerId: c.sellerId}));

      });
      this.makes$.subscribe(
        (makes: CarMake[]) => {
          this.makes = makes;
          this.selectedMake = makes.filter(mk => mk.name === this.selectedMake.name)[0];
        }
      )

      this.models$.subscribe(
        (models: CarModel[]) => {
          this.models = models;
          this.selectedModel = models.filter(md => md.name == this.selectedModel.name)[0];
        }
      )

      this.versions$.subscribe(
        (versions: CarVersion[]) => {
          this.versions = versions;
          this.selectedVersion = versions.filter(vr => vr.name == this.selectedVersion.name)[0];
        }
      )

    this.carImagesFolder$.subscribe(
      (imgdts) => {
          //this.carImagesFolder = imgdts!;
          if(imgdts != undefined){
            this.carImage = imgdts![0]!.blob;
          }
          
      });

    this.jobTemplates$.subscribe(
      (jobTemplates: CarJobTemplate[]) => {
        this.jobTemplates = jobTemplates;
      }
    )

    //this.currentBooking.startDate = this.searchCriteriaStartDate;
    //this.currentBooking.endDate = this.searchCriteriaEndDate;
  }

  private _filterJobTemplatesGroup(value: string): JobTemplatesGroup[] {
    //console.log('hellooo' +value)
    if (value) {
      return this.jobTemplatesGroups
        .map(group => ({category: group.category, templates: _filterByValue(group.templates, value)}))
        .filter(group => group.templates.length > 0);
    }

    return this.jobTemplatesGroups;
  }

  private _filterJobTemplates(value: string): JobTemplatesGroup[] {
    console.log('hellooo' +value)

    let tm: JobTemplatesGroup[] = []
    let t: JobTemplatesGroup[] = []
    if (value) {
      return this.jobTemplates
        .map(jobTemplate => ({category: jobTemplate.category, templates: _filterByCategoryAndValue( this.jobTemplates, jobTemplate.category, value)}))
        
        .filter((group, index) => group.templates.length > 0 );
    }
    else{
      return this.jobTemplates
        .map(jobTemplate => ({category: jobTemplate.category, templates: _filterByCategoryAndValue( this.jobTemplates, jobTemplate.category, value)}))
        //.map(jobTemplate => ({category: jobTemplate.category, templates: this.jobTemplates }))
        
        .filter( (group, index) => group.templates.length > 0);
    }

    // const t =  tm.filter((element, index) => {
    //   return tm.indexOf(element) === index;
    // })

    //t = tm.reduce( (temG, group) => temG, [])

    //return t;
  }

  private _filterJobTemplatesMap(value: string): Map<CarJobCategory, CarJobTemplate[]> {

    const tempMap: Map<CarJobCategory, CarJobTemplate[]> = new Map<CarJobCategory, CarJobTemplate[]>();

    this.jobTemplates
    .filter(item => ( !this.indices.has(item.id) && (item.code.toLowerCase().includes(value) || item.title.toLowerCase().includes(value) )))
    .forEach(
      temp => {
        if(tempMap.get(temp.category) == undefined ){
          tempMap.set(temp.category, [])
        }
        tempMap.get(temp.category)?.push(temp)
      }
    )
    return tempMap;
  }



  getCarModelsFromFile(mk: string): string[]{
    return CarBasicData.getModelsBD([mk]);
  }

  onMakeChange(make: CarMake){
    this.currentAppointment.carMake = make.name;
    this.currentAppointment.carModel = '';
    this.currentAppointment.carVersion = '';
    this.store.dispatch(CarRefActions.modelsFetchSubmit( { makeIds: [make.id] } ));

  }

  onModelChange(model: CarModel){
    this.currentAppointment.carModel = model.name;
    this.currentAppointment.carVersion = '';
    this.store.dispatch(CarRefActions.versionsFetchSubmit( { modelIds: [model.id] } ));
  }

  onVersionChange(version: CarVersion){
    console.log(version);
    this.currentAppointment.carVersion = version.name;
  }

  getCarImage(): any{

    let objectUrl = URL.createObjectURL(this.carImage!);     
    return this.sanitizer.bypassSecurityTrustUrl(objectUrl); 

  }

  updateCurrentPaymentTermOption(index: number){

    console.log(index);
    this.currentPaymentTermOptionIndex = index;
    //this.currentBooking.paymentTermOption = this.paymentTermOptions[index].code;
  }

  onServiceTypeChange(){

  }

  
  onLocationModeChange(){

  }

  onEmergencyChange(){

  }

  onNewCarChange(){

  }

  onJobTemplateSelected(e: CarJobTemplate){
    
    if(!this.indices.has(e.id)){
      this.currentAppointment.jobTemplates.push(e);
      this.indices.add(e.id);
    }
    console.log('helloo ' +e)
  }

  removeJobTemplateSelected(id: number){
    
    if(this.indices.has(id)){
      this.currentAppointment.jobTemplates = this.currentAppointment.jobTemplates.filter(jt => jt.id !== id);
      this.indices.delete(id);
    }
    //console.log('helloo ' +e)
  }

  getCitiesforCountry(countryCode: string): string[]{
    return GeneralBasicData.getAllCities([countryCode]);
  }

  onSelectedDatesChange(event: any){
    console.log('hellooo '+event.value);
    
  }

  filterPastDates = (date: Date | null): boolean => {
    return (date! > this.yesterdayDate);
  }

  dateFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

  moneyFormat(s: string): string{
    return AppFunctions.numberWithSpaces(s);
  }

  calculateCarAmount(){
    //return this.currentBooking.getTotalDuration() * this.currentCar.rentPrice.amount;
  }

  calculateInsuranceAmount(){
    //return this.currentBooking.getTotalDuration() * this.insuranceDayRate;
  }

  calculateDriverAmount(){
    //return this.currentBooking.getTotalDuration() * this.driverDayRate;
  }

  calculateTotalAmount(){
    //return this.calculateCarAmount() + this.calculateInsuranceAmount() + (this.calculateDriverAmount()*+this.currentBooking.withDriver)
  }

  goToConfirmBookingSubmitOld(){

    //console.log(this.currentBooking);

    // this.router.navigate(
    //   ['/rent/booking-validate'],
    //   { queryParams: { id: sellerId } }
    // );

    //this.store.dispatch(DealerActions.bookingNewSubmit({carId: this.carId, booking: this.currentBooking  }));
        
  }

  confirmAppointmentSubmit(){

    this.currentAppointment.carId = this.currentCar.carId;
    this.currentAppointment.customerId = this.currentUserId;
    this.currentAppointment.providerId = this.currentAppointment.providerId;

    console.log(this.currentAppointment);

    this.store.dispatch(CommonActions.appointmentNewSubmit({ appointment: this.currentAppointment, objectSource: this.objectSource }));
        
  }

}

